// import react packages
import React, { useState } from "react";
import { useMutation } from "react-apollo";

// Import Polaris Components
import { Button, Modal } from "@shopify/polaris";

// import helpers
import constant from "lib/constant/constant";
import { baseHelper, errorHelper } from "lib/helpers";

// import gql
import { DISCONNECT_BIGCOMMERCE_SHOP } from "app/productLake/apollo/mutations";

// import props
import { connectedShopProp } from "app/product/modules/generic/propTypes";

const ConnectedShop = (props) => {
  const { currentUserData, setBanner, setIsConnected, setValue, cms } = props;
  const { storeConfig = {} } = currentUserData || {};
  const { bigCommerce = {} } = storeConfig || {};
  const { shopDomain = "" } = bigCommerce || {};
  const { DISCONNECT_BIGCOMMERCE_SHOP: DISCONNECT } = constant.gql;
  const [isDisconnectActive, setIsDisconnectActive] = useState(false);

  const [disconnectShop, { loading: disconnectLoading }] = useMutation(DISCONNECT_BIGCOMMERCE_SHOP);

  const disconnectShopConfirm = async () => {
    try {
      const response = await disconnectShop({
        variables: { input: { id: currentUserData._id } },
      });
      const responseError = baseHelper.getResponseError(response.data, DISCONNECT);
      if (responseError) {
        setIsDisconnectActive(false);
        setBanner({ isOpen: true, status: constant.CRITICAL, title: responseError });
        return;
      }
      setBanner({ isOpen: true, status: constant.SUCCESS, title: cms("section.connect.message.success.disconnected") });
      setIsConnected(false);
      setValue({
        accessToken: "",
        clientId: "",
        clientSecret: "",
        shopDomain: "",
      });
    } catch (exception) {
      setBanner({ isOpen: true, status: constant.CRITICAL, title: errorHelper.parse(exception) });
    }
  };

  const handleDisconnectModal = () => {
    setIsDisconnectActive(!isDisconnectActive);
  };

  return (
    <>
      <Modal
        open={isDisconnectActive}
        onClose={handleDisconnectModal}
        title={cms("section.connect.label.disconnectShop")}
        primaryAction={{
          content: `${cms("section.connect.label.disconnectShop")} ${shopDomain}`,
          onAction: disconnectShopConfirm,
          destructive: true,
          loading: disconnectLoading,
        }}
        secondaryActions={[
          {
            content: cms("section.connect.button.cancel"),
            onAction: handleDisconnectModal,
          },
        ]}
      >
        <Modal.Section>{`${cms("section.connect.label.disconnectWoocommerceShop")} ?`}</Modal.Section>
      </Modal>
      <Button plain destructive id="disconnect" onClick={handleDisconnectModal}>
        {cms("section.connect.label.disconnectShop")}
      </Button>
    </>
  );
};

ConnectedShop.propTypes = connectedShopProp;

export default ConnectedShop;
